import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Hide AbortError overlay caused by browser extensions (MetaMask etc)
if (process.env.NODE_ENV === 'development') {
  const hideOverlay = () => {
    const overlay = document.querySelector('iframe[style*="z-index: 2147483647"]');
    if (overlay) overlay.remove();
    
    const divs = document.querySelectorAll('div');
    divs.forEach(div => {
      if (div.shadowRoot) {
        const root = div.shadowRoot.querySelector('#react-error-overlay-root');
        if (root) root.remove();
      }
    });
  };
  
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.name === 'AbortError' || 
        e.reason?.message?.includes('aborted')) {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(hideOverlay, 100);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);